import { InfoBold } from "@/assets";
import { Modal } from "@/components";
import { REMAIN_ANNUAL_LEAVE_BY_FINANCIAL_AND_EMPLOYEE } from "@/store/mutation-types/filters.type";
import {
  countDecimals,
  CREATE_TYPE,
  DATE_FORMAT_V2,
  DATE_FORMAT_V2_FULL,
  EDIT_TYPE,
  getInfoStaff,
  handleMessagesAPI,
  isNumeric,
  OBJECT_TYPES,
  REMOVE_TYPE,
} from "@/utils";
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "AnnualLeaveModal",
  components: {
    Modal,
  },
  emits: ["onCancel"],
  props: {
    visibleModal: {
      type: Boolean,
      require: true,
    },
    data: {
      type: Object,
    },
    type: {
      type: String,
    },
  },
  data() {
    return {
      DATE_FORMAT_V2,
      CREATE_TYPE,
      REMOVE_TYPE,
      OBJECT_TYPES,
      EDIT_TYPE,
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 18, offset: 1 },
      },
      formRQ: this.$form.createForm(this, { name: "formLeaveCarryover", onValuesChange: this.onValuesChange }),
      formData: {},
      fetching: false,
      timeout: null,
      loading: false,
      InfoBold,
      remainAnnualLeave: null,
      disabledApplyDate: false,
    };
  },
  watch: {
    computeProps() {
      if (this.visibleModal) {
        this.handleInitFormData();
      }
    },
  },
  computed: {
    ...mapState({
      employeeList: (state) => state.filters.employeeList,
      financialYearList: (state) => state.advance.financialYearList,
      remainAnnualLeaveByFinancialAndEmployee: (state) => state.filters.remainAnnualLeaveByFinancialAndEmployee,
      timeServer: (state) => state.application.timeServer,
      mostRecentTimeSheetApproved: (state) => state.advance.mostRecentTimeSheetApproved,
    }),
    generateTitle() {
      switch (this.type) {
        case CREATE_TYPE:
          return "Add Leave Carryover";
        case EDIT_TYPE:
          return "Edit Leave Carryover";
        case REMOVE_TYPE:
          return "Please Confirm";
        default:
          return "Add Leave Carryover";
      }
    },
    generateAnnualLeave() {
      const { remainAnnualLeaveByFinancialAndEmployee } = this;
      if (remainAnnualLeaveByFinancialAndEmployee) {
        const { hours } = remainAnnualLeaveByFinancialAndEmployee;
        return `${hours ?? 0} hours`;
      }
      return "";
    },
    computeProps() {
      const { type, data } = this;
      return { type, data };
    },
  },
  async created() {
    // Get time server
    await this.$store.dispatch("application/getTimeServer");
    // Get recent timesheet approved
    this.$store.dispatch("advance/getMostRecentTimeSheetApproved");

    // // Get financial year
    try {
      const { data } = await this.$store.dispatch("advance/getFinancialYear");
      console.log("🚀 ~ file: index.js:107 ~ created ~ data:", data);
      if (this.type === CREATE_TYPE && data) {
        this.formData = { ...this.formData, financialYear: data };
      }
    } catch (error) {
      handleMessagesAPI(error.response.data);
    }
    // Handle Init Form Data
    if (this.visibleModal) {
      this.handleInitFormData();
    }
  },

  methods: {
    getInfoStaff,
    handleInitFormData() {
      const { type, data } = this;
      if (data && type === EDIT_TYPE) {
        const { username, leaveHours, applyDate, expireDate, description, fullName, financialYear, usedHours } = data;
        this.formData = {
          username,
          leaveHours,
          description,
          applyDate: moment(applyDate, DATE_FORMAT_V2) ?? null,
          expireDate: moment(expireDate, DATE_FORMAT_V2) ?? null,
          staff: fullName,
          financialYear,
        };
        // Get remain annual leave
        if (financialYear && username) {
          this.getRemainAnnualLeaveByFinancialAndEmployee(username, financialYear);
        }

        // Get most recent timesheet approved
        if (applyDate) {
          this.disabledApplyDate =
            moment(applyDate, DATE_FORMAT_V2_FULL).isSameOrBefore(
              moment(this.timeServer, DATE_FORMAT_V2_FULL).startOf("day")
            ) && usedHours > 0;
        }
      }
      if (type === CREATE_TYPE) {
        this.formData = { ...this.formData, financialYear: this.financialYearList?.[0] ?? "" };
      }
    },
    handleChangeFinancialYear(value) {
      this.formRQ.setFieldsValue({ financialYear: value, leaveHours: "" });
      const { username } = this.formRQ.getFieldsValue();
      const { type, data } = this;

      if (!value || (type === CREATE_TYPE && !username) || (type === EDIT_TYPE && !data?.username)) {
        this.remainAnnualLeave = null;
      } else {
        if (type === CREATE_TYPE) {
          this.getRemainAnnualLeaveByFinancialAndEmployee(username, value);
        } else {
          this.getRemainAnnualLeaveByFinancialAndEmployee(data.username, value);
        }
      }
    },
    handleChangeStaff(value) {
      this.formRQ.setFieldsValue({ username: value, leaveHours: "" });
      const { financialYear } = this.formRQ.getFieldsValue();
      if (!value) {
        this.$store.commit(`filters/${REMAIN_ANNUAL_LEAVE_BY_FINANCIAL_AND_EMPLOYEE}`, null);
        return;
      }
      if (financialYear) {
        this.getRemainAnnualLeaveByFinancialAndEmployee(value, financialYear);
      }
    },
    getRemainAnnualLeaveByFinancialAndEmployee(username, financialYear) {
      this.$store.dispatch("filters/getRemainAnnualLeaveByFinancialAndEmployee", {
        username,
        financialYear,
      });
    },
    generateValue(key) {
      const { data } = this;
      if (!data) return "";
      switch (key) {
        case "fullName":
          return data[key];
        case "un_allowed_leave":
          return `${data[key]} ngày ${data?.["unAllowedLeave"]?.length > 0 ? `(${data["unAllowedLeave"]}) ` : ""}`;
        default:
          return `${data[key]} ngày`;
      }
    },
    handleDisabledApplyDate(date) {
      const { mostRecentTimeSheetApproved } = this;
      const expireDate = this.formRQ.getFieldValue("expireDate");

      return (
        (expireDate && moment(date).startOf("day").isAfter(moment(expireDate).startOf("day"))) ||
        moment(date).isBefore(moment(mostRecentTimeSheetApproved, DATE_FORMAT_V2_FULL).add(1, "days"))
      );
    },
    handleDisabledExpireDate(date) {
      const applyDate = this.formRQ.getFieldValue("applyDate");
      return (
        (applyDate && moment(date).isBefore(moment(applyDate))) ||
        moment(date).startOf("day").isBefore(moment(this.timeServer, DATE_FORMAT_V2_FULL).startOf("day"))
      );
    },
    onSearchStaff(value, timeout = 1000) {
      if (!value || !value.trim() || value.trim().length <= 2) return;
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.fetching = true;
      this.timeout = setTimeout(async () => {
        try {
          await this.$store.dispatch("filters/getEmployeeList", value);
        } catch (error) {
          handleMessagesAPI(error.response.data);
        } finally {
          this.fetching = false;
        }
      }, timeout);
    },

    validateNumber(rule, value, callback) {
      if (value) {
        const hours = this.remainAnnualLeaveByFinancialAndEmployee?.hours;
        if (hours === undefined) {
          callback();
        }
        if (!isNumeric(value)) {
          callback("Leave hour(s) is invalid");
        } else if (Number(value) > hours || Number(value) <= 0) {
          callback(`Leave hour(s) must be between 0 and ${hours}`);
        } else if (countDecimals(Number(value)) >= 2 || Number(value) % 0.5) {
          callback("Invalid duration (ex: 0.5, 1 , 1.5, 2, 2.5, ...) ");
        }
      }
      callback();
    },
    onCancel() {
      this.formRQ.resetFields();
      this.formData = {};
      this.$emit("onCancel");
      this.$store.commit(`filters/${REMAIN_ANNUAL_LEAVE_BY_FINANCIAL_AND_EMPLOYEE}`, null);
      this.disabledApplyDate = false;
    },

    //#region handle Ok form
    onOk() {
      this.formRQ.validateFields(async (error, values) => {
        if (error) return;
        values.applyDate = moment(values.applyDate).format(DATE_FORMAT_V2_FULL);
        values.expireDate = moment(values.expireDate).format(DATE_FORMAT_V2_FULL);
        this.loading = true;
        const { type, data } = this;
        let payload = { ...values, usernames: [values.username] };
        let action = "";
        if (type === CREATE_TYPE) {
          action = "addLeaveCarryover";
          payload = { ...payload };
        } else if (type === EDIT_TYPE) {
          action = "editLeaveCarryover";
          payload = { ...data, ...payload };
        } else if (type === REMOVE_TYPE) {
          action = "deleteLeaveCarryover";
          payload = { id: data.id };
        }

        try {
          const res = await this.$store.dispatch(`leaveCarryover/${action}`, payload);
          const { code } = res;
          handleMessagesAPI(res);
          if (code == 200) {
            this.$emit("getData");
            this.onCancel();
          }
        } catch (error) {
          handleMessagesAPI(error.response.data);
        } finally {
          this.loading = false;
        }
      });
    },
    //#endregion
  },
};
